import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, TextField } from "@mui/material";

/**
 * Read-only multiline text area displaying a code snippet with a corner copy button.
 *
 * @param {Object} props
 * @param {string} props.label - TextField label.
 * @param {string} props.value - Snippet contents to display.
 * @param {string} props.copyAriaLabel - Accessible label for the copy icon button.
 * @param {(event: import("react").MouseEvent<HTMLButtonElement>) => void} props.onCopy - Click handler for the copy button.
 * @param {number} [props.minRows=6] - Minimum visible rows for the textarea.
 * @returns {import("react").ReactElement}
 */
export function SnippetPreview(props) {
  const { label, value, copyAriaLabel, onCopy, minRows = 6 } = props;

  return (
    <Box sx={{ position: "relative" }}>
      <TextField
        label={label}
        value={value}
        multiline
        minRows={minRows}
        fullWidth
        InputProps={{ readOnly: true }}
      />
      <IconButton
        aria-label={copyAriaLabel}
        onClick={onCopy}
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
